<template>  
  <div id="main-menu-bar" class="text-center" v-if="user.core_role_id > 0 && user.core_role_id < 13">
    <div class="cont-frist-icon mt-0 mb-0 d-none d-lg-block">
      <!--span class="icon-logovp"></span-->
      <img src="@/assets/images/icons/logovp.svg" width="100%" />
    </div>
    
    <div class="cont-buttons d-flex flex-lg-column justify-content-around">
      <!--div class="mb-3 d-none d-lg-block d-xl-table"></div-->

      <div v-if="user.core_role_id == '1'">
        <router-link to="/homerequest" class="menu-button">
          <span class="icon icon-table-edit"></span>
          <p class="mb-0 d-none d-lg-block">Nueva solicitud</p>
        </router-link>
      </div>

     <!-- <div v-if="user.core_role_id == '2' || user.core_role_id == '3' || user.core_role_id == '4'">
        <router-link to="/homeProcesses" class="menu-button">
          <span class="icon icon-table"></span>
          <p class="mb-0 d-none d-lg-block">Nuevo Proceso</p>
        </router-link>
      </div> -->

      <div v-if="user.core_role_id == '6'">
        <router-link to="/settle" class="menu-button">
          <span class="icon icon-table"></span>
          <p class="mb-0 d-none d-lg-block">Solicitudes</p>
        </router-link>
      </div>
      <div v-else-if="user.core_role_id == '8' || user.core_role_id == '9'">
        <router-link to="/listRP" class="menu-button">
          <span class="icon icon-table"></span>
          <p class="mb-0 d-none d-lg-block">Solicitudes</p>
        </router-link>
      </div>
      <div v-else>
        <!-- Gestor de tiquetes -->
        <template v-if="user.core_role_id == '7' || user.core_role_id == '4'">
          <router-link to="/requests-gestor-impuestos" class="menu-button">
            <span class="icon icon-table"></span>
            <p class="mb-0 d-none d-lg-block">Solicitudes tiquetes</p>
          </router-link>
        </template>
        <template v-if="user.core_role_id == '4' || user.core_role_id == '2' || user.core_role_id == '3' || user.core_role_id == '1'">
          <!-- Relaciones laborales & Bussiness Partner & Aprobador & Solicitante Sindical -->
          <router-link to="/solicitudes" class="menu-button">
            <span class="icon icon-table"></span>
            <p class="mb-0 d-none d-lg-block">Solicitudes</p>
          </router-link>
        </template>
        <!-- Relaciones laborales & Bussiness Partner -->
        <!-- <template v-if="user.core_role_id == '4' || user.core_role_id == '2'">
          <router-link to="/solicitudes-bp" class="menu-button">
            <span class="icon icon-table"></span>
            <p class="mb-0 d-none d-lg-block">Solicitudes BP</p>
          </router-link>
        </template> -->
      </div>
      
      <router-link v-if="canWithCode('relaciones-laborales', 'business-partner')" to="/dashboard" class="menu-button">
        <span class="icon icon-dashboard"></span>
        <p class="mb-0 d-none d-lg-block">Estadísticas</p>
      </router-link>
      
      <router-link to="/help" class="menu-button">
        <span class="icon icon-circle-help"></span>
        <p class="mb-0 d-none d-lg-block">Ayuda</p>
      </router-link>
      
      <div v-if="user.core_role_id == '1'">
        <router-link to="/editletter" class="menu-button">
          <span class="icon icon-layout-edit"></span>
          <p class="mb-0 d-none d-lg-block">Editar plantilla</p>
        </router-link>
      </div>
      <!-- MENU ASIGNADO DE LA CARGA DE FOTOS Y TELEFONOS -->

      <div v-if="getAttributeUserData('responsible_upload_photos')">
        <router-link to="/uploadPhotos" class="menu-button">
          <img class="p-0 mx-auto mb-3" src="@/assets/images/icons/photo.svg">
          <p class="mb-0 d-none d-lg-block">Carga de fotografías</p>
        </router-link>
      </div>

      <div v-if="getAttributeUserData('responsible_upload_phones')">
        <router-link to="/uploadPhones" class="menu-button">
          <img class="p-0 mx-auto mb-3" src="@/assets/images/icons/phone.svg">
          <p class="mb-0 d-none d-lg-block">Teléfono de contacto</p>
        </router-link>
      </div>
      <div>
        <a class="menu-button" href="https://anheuserbuschinbev.sharepoint.com/sites/PeopleparaPeople" target="blanck">
          <img class="p-0 mx-auto" src="@/assets/images/icons/Group.svg" width="80%">
        </a>
      </div>
      <!--div v-if="user.core_role_id == '1'">
        <router-link to="/rightpetition" class="menu-button">
          <p class="mb-0 d-none d-lg-block">Derechos</p>
        </router-link>
      </div-->
      <!-- <footer class="w-100 position-absolute d-none ">
        <img src="@/assets/images/icons/open_menu.svg" alt="Abrir menú" />
      </footer>    -->
    </div>
  </div>  
  <!-- #main-menu-bar -->  
</template>

<script>
import { mapState,mapActions } from "vuex";
import serverConfig from "./../../services/config";
export default {
  name: "MainBarMenu",
  data() {
    return {
      serverPath: serverConfig.permisosURL,
    }
  },
  beforeMount() {
    this.actUserLocalStorage(); 
    this.abrir = localStorage.abrir;
  },
  computed: {
    ...mapState("modCore", ["user"]),
  },
  methods: {
    ...mapActions("modCore", ["actUserLocalStorage"]),
  },
};
</script>

<style lang="scss" scoped>
#main-menu-bar {
  width: 100%;
  background-color: #1c6776;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
  position: fixed;
  z-index: 50;
  bottom: 0;
  left: 0;
  height: 50px;

  .cont-frist-icon {
    font-size: 20px;
    background-color: #FFFFFF;
    padding: 3px;
  }

  .cont-buttons {
    padding: 0 6px;
    .separator {
      width: 100%;
      height: 1px;
      background-color: #ffffff;
    }

    .menu-button {
      color: #ffffff;
      display: block;
      border-radius: 5px;
      padding: 15px;

      .icon {
        font-size: 24px;
      }

      p {
        font-size: 12px;
        line-height: 16px;
      }

      &:hover {
        background: #1c3a4e;
      }

      @media (min-width: 992px) {
        padding: 15px 5px;
      }
    }

    .router-link-exact-active {
      background: #1c3a4e;
    }
  }

  footer {
    background: #1c3a4e;
    border-radius: 5px;
    left: 0;
    bottom: 0;
    padding: 5px 5px;
  }

  @media (min-width: 992px) {
    width: 86px;
    height: calc(100vh - 30px);
    border-radius: 5px;
    //position: relative;
    position: sticky;
    position: -webkit-sticky;
    top: 15px;
    //position: fixed;    
  }
}
</style>